import {BrowserRouter as Router, Route, Routes, useLocation} from "react-router-dom";
import {useEffect} from "react";
import HomeOne from "./components/pages/homes/home";
import AboutUs from "./components/pages/about";
import ServicePage from "./components/pages/services/service";
import TeamPageTwo from "./components/pages/teams/team-2";
import PortfolioFilterPage from "./components/pages/gallery";
import PortfolioThreeColumns from "./components/pages/portfolio/3-columns";
import History from "./components/pages/history";
import ContactUs from "./components/pages/contacts";
import BlogStandardPage from "./components/pages/blogs/blog-standard";
import ServicesDetails from "./components/pages/services/service-single";
import PortfolioDetails from "./components/pages/portfolio/portfolio-details";
import BlogDetails from "./components/pages/blogs/blog-details";

import {animationCreate} from ".";
import CustomCursor from "./components/pages/common/cursor";
import ScrollToTop from "./components/layout/reusable/ScrollToTop";
import ScrollToTopIcon from "./components/pages/common/scroll/scroll-to-top";
import UnderMaintenance from "./components/pages/undermaintenance";
import RecruitmentIndex from "./components/pages/recruitment";
import RecruitmentDetails from "./components/pages/recruitment/DetailRecruitment";

function App() {
    const ScrollReset = () => {
        const {pathname} = useLocation();

        useEffect(() => {
            window.scrollTo(0, 0);
        }, [pathname]);

        return null;
    };

    useEffect(() => {
        setTimeout(() => {
            animationCreate();
        }, 500);
    }, []);

    return (
        <Router>
            <ScrollReset/>
            <CustomCursor/>
            <Routes>
                <Route path="/" element={<HomeOne/>}/>
                <Route path="/about-us" element={<AboutUs/>}/>
                <Route path="/history" element={<History/>}/>
                <Route path="/services" element={<ServicePage/>}/>
                <Route path="/services/:id" element={<ServicesDetails/>}/>
                <Route path="/team" element={<TeamPageTwo/>}/>
                <Route path="/gallery" element={<PortfolioFilterPage/>}/>
                <Route path="/portfolio" element={<PortfolioThreeColumns/>}/>
                <Route path="/portfolio/:id" element={<PortfolioDetails/>}/>
                <Route path="/blog" element={<BlogStandardPage/>}/>
                <Route path="/blog/:id" element={<BlogDetails/>}/>
                <Route path="/contact-us" element={<ContactUs/>}/>
                <Route path="/recruitment" element={<RecruitmentIndex/>}/>
                <Route path="/recruitment/:id" element={<RecruitmentDetails/>}/>
                <Route path="/under-maintenance" element={<UnderMaintenance/>}/>
            </Routes>

            <ScrollToTop/>
            <ScrollToTopIcon/>
        </Router>
    );
}

export default App;
